<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Dropdown } from '@/components/primitives'
import {
  SunIcon as IconThemeLight,
  SunDim as IconThemeSoftLight,
  LampDesk as IconThemeGraceDark,
  TentTree as IconThemeSlate,
  Lightbulb as IconThemeFlatLight,
  LightbulbOff as IconThemeFlatDark,
  Sunset as IconThemeFlightDark,
  Heart as IconThemePink,
  TentTree as IconThemeGreen,
  PaletteIcon as PaletteIcon,
} from 'lucide-vue-next'
import { useDataTheme } from '@/theme/use-data-theme'
import { getDistinctCssClasses } from '@tenorlab/vue-dashboard/core'

const themes = [
  { icon: IconThemeLight, key: 'grace-light', name: 'Grace Light' },
  { icon: IconThemeSoftLight, key: 'soft-light', name: 'Soft Light' },
  { icon: IconThemeGraceDark, key: 'grace-dark', name: 'Grace Dark' },
  { icon: IconThemeFlightDark, key: 'flight-dark', name: 'Flight Light' },
  { icon: IconThemeSlate, key: 'slate', name: 'Slate' },
  { icon: IconThemeFlatDark, key: 'flat-dark', name: 'Flat Dark' },
  { icon: IconThemeFlatLight, key: 'flat-light', name: 'Flat Light' },
  { icon: IconThemePink, key: 'crazy-pink', name: 'Crazy Pink' },
  { icon: IconThemeGreen, key: 'pine', name: 'Pine' },
]

const themeLocalStorage = useDataTheme()

const isOpen = ref(false)
const currentTheme = ref(themeLocalStorage.getCurrentDataTheme())

const getButtonCss = (key: string) => {
  return getDistinctCssClasses(
    `w-full flex items-center gap-2 px-2 py-1 text-left text-sm cursor-pointer border`,
    key !== currentTheme.value
      ? `border-transparent content-topbar hover:bg-primary hover:content-primary`
      : 'border-primary text-primary',
  )
}

const handleToggleOpen = (value: boolean) => {
  isOpen.value = value
}

const handleThemeButtonClick = (key: string) => {
  currentTheme.value = key
  themeLocalStorage.setDataTheme(key)
}

onMounted(() => {
  //themeLocalStorage.restoreDataTheme()
})
</script>

<template>
  <div className="absolute top-4 right-0">
    <Dropdown :enabled="true" :isMenuOpen="isOpen" @toggleOpen="handleToggleOpen">
      <template #icon>
        <div class="group flex items-center gap-2 text-primary group-hover:text-primary-inverse">
          <span class="sr-only">Open themes menu</span>
          <PaletteIcon class="size-6 text-primary group-hover:text-primary-inverse" aria-hidden="true" />
        </div>
      </template>
      <template #default>
        <div class="px-2">
          <h5 class="px-2 py-2 font-bold">Choose theme:</h5>
          <button
            v-for="themeInfo in themes"
            :key="themeInfo.key"
            type="button"
            :class="getButtonCss(themeInfo.key)"
            role="menuitem"
            tabindex="-1"
            @click.stop="() => handleThemeButtonClick(themeInfo.key)"
          >
            <component :is="themeInfo.icon" />
            <span>{{ themeInfo.name }}</span>
          </button>
        </div>
      </template>
    </Dropdown>
  </div>
</template>
